import React from 'react';
import { CategoryTabsProps } from './types';
import styles from './CategoryTabs.module.css';

export const CategoryTabs: React.FC<CategoryTabsProps> = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange 
}) => {
  const handleCategoryClick = (category: typeof categories[number]) => {
    onCategoryChange(category);
  };

  const handleKeyDown = (event: React.KeyboardEvent, category: typeof categories[number]) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onCategoryChange(category);
    }
  };

  return (
    <div className={styles.categoryTabs} role="tablist" aria-label="Categorii de template-uri">
      {categories.map((category) => (
        <button
          key={category}
          className={`${styles.categoryTab} ${selectedCategory === category ? styles.active : ''}`}
          onClick={() => handleCategoryClick(category)}
          onKeyDown={(e) => handleKeyDown(e, category)}
          role="tab"
          aria-selected={selectedCategory === category}
          aria-controls={`panel-${category.toLowerCase()}`}
          tabIndex={selectedCategory === category ? 0 : -1}
        >
          {category}
        </button>
      ))}
    </div>
  );
}; 